import { analyticsDimensionsManager, analyticsRoutesManager } from "@core/service-container";
import React, { PropsWithChildren, useEffect } from "react";
import { useLocation } from "react-router";

export const AnalyticsRoute: React.FC<PropsWithChildren> = ({ children }) => {
	const location = useLocation();

	useEffect(() => {
		analyticsDimensionsManager.computeCustomDimensions();
		analyticsRoutesManager.setCurrentRoute(location);
	}, [location]);

	return <>{children}</>;
};
